module.exports = __webpack_public_path__ + "/bundle/asset/U2_03-9cfc9be1bbb618feaba910adea01eb92.gif";